import { EinConfigurationActionTypes, EinConfigurationActions } from './ein-configuration.actions';
import { IEinConfiguration } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    einConfig: IEinConfiguration[] | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    einConfig: null
};

export function reducer(state = initialState, action: EinConfigurationActions): State {
    switch (action.type) {

        case EinConfigurationActionTypes.LoadEinConfigurationState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case EinConfigurationActionTypes.LoadEinConfigurationStateSuccess: {
            return {
                error: null,
                pending: false,
                einConfig: action.payload
            };
        }


        case EinConfigurationActionTypes.SaveEINOrgDetail: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case EinConfigurationActionTypes.LoadEinConfigurationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case EinConfigurationActionTypes.EinConfigurationScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        case EinConfigurationActionTypes.EinConfigurationInitialState: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getEinConfig = (state: State) => state.einConfig;